module.exports = __webpack_public_path__ + "img/mastercard.8e830672.svg";